import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "sealpro_email_activationlink_modal",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content seq-modal" }
const _hoisted_4 = { class: "modal-header flex-stack" }
const _hoisted_5 = { class: "seq-page-title fs-2 mb-0" }
const _hoisted_6 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body scroll-y pt-10 pb-15 px-lg-17" }
const _hoisted_9 = { class: "seq-profile-form" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label mb-4" }, " Please input the Fullname, valid Email address and Contact Number of your recipient ", -1)
const _hoisted_11 = { class: "mb-5" }
const _hoisted_12 = { class: "mb-5" }
const _hoisted_13 = { class: "mb-5" }
const _hoisted_14 = { class: "text-center pt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("h2", _hoisted_5, "Send " + _toDisplayString(_ctx.coverage_type) + " Now", 1),
          _createVNode("div", _hoisted_6, [
            _createVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Close.svg" })
            ])
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode("div", _hoisted_11, [
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "seq-profile-input",
                id: "fullname",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.fullnameparam = $event)),
                placeholder: "Recipient's Fullname"
              }, null, 512), [
                [_vModelText, _ctx.fullnameparam]
              ])
            ]),
            _createVNode("div", _hoisted_12, [
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "seq-profile-input",
                id: "emailaddress",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.emailparam = $event)),
                placeholder: "Email Address"
              }, null, 512), [
                [_vModelText, _ctx.emailparam]
              ])
            ]),
            _createVNode("div", _hoisted_13, [
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "seq-profile-input",
                id: "contactno",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.contactparam = $event)),
                placeholder: "Contact Number"
              }, null, 512), [
                [_vModelText, _ctx.contactparam]
              ])
            ]),
            _createVNode("div", _hoisted_14, [
              _createVNode("button", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sendActivation())),
                class: "btn btn-sm btn-seq-green"
              }, " Send Activation ")
            ])
          ])
        ])
      ])
    ])
  ]))
}